import React, { useState } from 'react';
import styles from './UnauthorizedPageRoot.module.scss';
import Logo from 'assets/img/logo.svg?react';

import Footer from '../authorized/Footer.tsx';
import { AppLink } from '../../components/uikit/buttons/AppLink.tsx';
import LanguageSelector from '../../components/uikit/LanguageSelector.tsx';
import { Language } from '../../application/localization/locales.ts';
import { changeLanguage } from '../../application/localization/localization.ts';
import Logger from 'js-logger';
import { MatomoRouterTracker } from '../MatomoRouterTracker.tsx';
import clsx from 'clsx';
import { FeatureFlags } from '../../application/constants/env-variables.ts';

export const UnauthorizedPageRoot: React.FC<React.PropsWithChildren> = (
  props,
) => {
  const [isLanguageModalShown, setIsLanguageModalShown] = useState(false);

  const changelanguage = (language: Language) => {
    setIsLanguageModalShown(false);
    changeLanguage(language).catch((e) => Logger.error(e));
  };

  const toggleLanguageModal = () => {
    setIsLanguageModalShown((prevState) => !prevState);
  };

  return (
    <div
      className={styles.wrapper}
      onClick={() => {
        setIsLanguageModalShown(false);
      }}
    >
      <MatomoRouterTracker />

      <div className={styles.rowContainer}>
        <div>
          <AppLink to={'/'}>
            <div className={styles.lmtLogo}>
              <Logo />
            </div>
          </AppLink>
        </div>
        <div>
          <LanguageSelector
            changeLanguage={changelanguage}
            isInMenu={false}
            isLanguageModalShown={isLanguageModalShown}
            toggleLanguageModal={toggleLanguageModal}
          ></LanguageSelector>
        </div>
      </div>

      <div className={styles.alignFlexCenter}>
        <div className={styles.gridContainer}>
          <div
            className={clsx(
              styles.mainBackground,
              FeatureFlags.isSupplierPortal() && styles.backgroundSupplier,
            )}
          ></div>
          <div className={styles.loginContainer}>{props.children}</div>
        </div>
      </div>
      <div className={styles.footerWrapper}>
        <Footer />
      </div>
    </div>
  );
};
